export const SET_PLAYING = "SET_PLAYING";
export const SET_SIDE_PANNEL = "SET_SIDE_PANNEL";
export const SET_NIGHT_MODE = "SET_NIGHT_MODE";
